import {ChangeDetectionStrategy, Component} from '@angular/core';
import {BaseComponent} from 'compob2b-libs';

@Component({
    templateUrl: './add-product.component.html',
    styleUrls: ['./add-product.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class AddProductComponent extends BaseComponent {
}
